<button
  type="button"
  class="close float-right"
  style="margin-right: 10px"
  (click)="onNoClick()"
  [ngStyle]="{'outline':'0'}"
  name="close"
>
  <span aria-hidden="true">×</span>
</button>
